const sanityId = process.env.GATSBY_SANITY_ID
const token = process.env.SANITY_AUTH_TOKEN

export async function storeTxValuesInSanity(
  account: String,
  txId: String,
  countryCode: String
): Promise<never | any> {
  const myHeaders = new Headers()
  myHeaders.append("Authorization", `Bearer ${token}`)
  myHeaders.append("Content-Type", "application/json")

  const raw = JSON.stringify({
    mutations: [
      {
        create: {
          _type: "purchase",
          fields: [{ buyer: account, transactionHash: txId, countryCode }],
        },
      },
    ],
  })

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  }

  await fetch(
    `https://${sanityId}.api.sanity.io/v2021-06-07/data/mutate/production`,
    requestOptions
  )
}
